﻿<script setup lang="ts">
    import BSFormInputText from '@shared/components/BSFormInputText.vue';
    import RichEditor from '@shared/components/RichEditor/RichEditor.vue';
    import ImagePreview from '@shared/components/Images/ImagePreview.vue';
    import { ImageReference } from '@cwd/shared/components/Images/types';

    type Content = {
        title: string;
        introduction: string;
        consent: string;
        button: string;
        image: ImageReference | null;
    };

    const props = defineProps<Content>();
</script>

<script lang="ts"></script>

<template>
    <h4>{{ $Resources.FormEditorContentImageHeading }}</h4>

    <ImagePreview
        :image="props.image"
        @update:currentImage="(newValue: ImageReference) => $emit('update:currentImage', newValue)"
        @update:imageSrc="$emit('update:imageSrc')"></ImagePreview>

    <h4>{{ $Resources.FormEditorContentTextHeading }}</h4>

    <BSFormInputText
        class="form-group"
        :modelValue="props.title"
        @update:modelValue="(newValue: string) => $emit('update:title', newValue)"
        :label="$Resources.FormEditorContentTitleLabel"
        :placeholder="$Resources.FormEditorContentTitlePlaceholder"></BSFormInputText>

    <RichEditor
        :modelValue="props.introduction"
        :markOnly="true"
        :title="$Resources.FormEditorContentIntroductionLabel"
        @update:modelValue="(newValue: string) => $emit('update:introduction', newValue)"></RichEditor>

    <RichEditor
        :modelValue="props.consent"
        :markOnly="true"
        :title="$Resources.FormEditorContentConsentLabel"
        @update:modelValue="(newValue: string) => $emit('update:consent', newValue)"></RichEditor>

    <h4>{{ $Resources.FormEditorContentButtonHeading }}</h4>

    <BSFormInputText
        class="form-group"
        :modelValue="props.button"
        @update:modelValue="(newValue: string) => $emit('update:button', newValue)"
        :label="$Resources.FormEditorContentButtonLabel"
        :placeholder="$Resources.FormEditorContentButtonPlaceholder"></BSFormInputText>
</template>

<style scoped></style>
